// Initial State
const state = () => ({
    tyresData: {
        tyres: null,
        tyresBrands: null,
        tyresSeasonalities: null,
        tyresSpeedRating: null,
        tyresExtraServices: null,
        tyresAssemblyOptions: null,
        tyresQuality: null,
        tyresLoadRating: null,
        tyresCart: null,
        tyresCartAvailability: false,
    },
    tyresCart: null,
    tyresResponseServices: null
});

// Mutations
const mutations = {
    // Mutations Tyres Data
    setTyresData(state, payload) {
        state.tyresData.tyres = payload;
    },
    setAssemblyOptionsData(state, payload) {
        state.tyresData.tyresAssemblyOptions = payload
    },
    setTyresBrandsData(state, payload) {
        state.tyresData.tyresBrands = payload
    },
    setTyresSpeedRatingData(state, payload) {
        state.tyresData.tyresSpeedRating = payload
    },
    setTyresExtraServicesData(state, payload) {
        state.tyresData.tyresExtraServices = payload
    },
    setTyresSeasonalitiesData(state, payload) {
        state.tyresData.tyresSeasonalities = payload
    },
    setTyresQualityData(state, payload) {
        state.tyresData.tyresQuality = payload
    },
    setTyresLoadRatingData(state, payload) {
        state.tyresData.tyresLoadRating = payload
    },
    //Mutations Tyres Cart
    setTyresCartData(state, payload) {
        state.tyresData.tyresCart = payload;
    },
    //Check for cart availability
    setCartAvailabilityData(state, payload) {
        state.tyresData.tyresCartAvailability = payload;
    },

    setTyresResponseServices(state, payload) {
        state.tyresResponseServices = payload;
    },

    // Clear cart tyres module
    clearCartTyresModule(state) {
        state.tyresData = {
            tyres: null,
            tyresBrands: null,
            tyresSeasonalities: null,
            tyresSpeedRating: null,
            tyresExtraServices: null,
            tyresAssemblyOptions: null,
            tyresQuality: null,
            tyresLoadRating: null,
            tyresCart: null,
            tyresCartAvailability: false,
        }
    }

  };

  // Actions
const actions = {

  };

  // Getters
const getters = {
    // Getters para o TyresData
    getTyresState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getAssemblyOptionsState(state) {
         for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresBrandsState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresSpeedRatingState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresExtraServicesState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresSeasonalitiesState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresQualityState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    getTyresLoadRatingState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    //Getters para o carrinho de pneus tyresCart
    getTyresCartState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    // Get cart availability
    getCartAvailabilityState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
    
    getTyresResponseServices(state) {
        return state.tyresResponseServices;
    },
  };

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
